import * as papaparse from 'papaparse';

// papaparse does not provide an ESM module, causing the import to not work properly.
// See https://github.com/mholt/PapaParse/issues/939

export const { parse } = ((papaparse as any).default ?? papaparse) as typeof papaparse;
